// Family Types routes
export default [
  {
    path: 'family-types',
    name: 'familyTypes',
    redirect: 'family-types/index',
    component: () =>
      import(
        /* webpackChunkName: "familyTypes" */ '../views/familyTypes/FamilyTypes.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'familyTypesIndex',
        meta: {
          tabbable: true,
          tableKeys: ['familyTypes'],
          filterKeys: [],
          formKeys: [],
          routePermissions: ['familyTypeView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "familyTypesIndex" */ '../views/familyTypes/FamilyTypesIndex.vue'
          ),
      },
    ],
  },
];
